import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled, { withTheme } from 'styled-components'
import ReactSVG from 'react-svg'
import Aside from '../CompanyProfileAside/ProfileAside'
import ImageSlider from '../ImageSlider'
import ImageToCanvas from '../ImageToCanvas'
import { H4, H5 } from '../TextPrimitives'
import Button from '../Button'
import { getMarkerSize } from '../Map'
import shapeSmall from './shape-small.svg'
import shapeSmallNoimage from './shape-small-noimage.svg'
import shapeLarge from './shape-large.svg'
import shapeLargeNoimage from './shape-large-noimage.svg'
import { shadowLowText, shadowHighDrop } from '../../style-functions'

// TODO: wait until svgs are loaded OR bundle SVG into code

const shapes = [
  [shapeSmallNoimage, shapeSmall],
  [shapeLargeNoimage, shapeLarge],
]

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  top: -${({ expand, offset }) => offset / 2 + (expand ? 104 : 64)}px;
  left: -${({ expand, hasImage }) => (expand ? (hasImage ? 922 : 317) : 144)}px;
`

const CloseButton = styled(Button)`
  position: absolute;
  top: 0rem;
  right: 0rem;
  z-index: 3;
  transform: translate(50%, -50%);
`

const SVG = styled(ReactSVG)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  div {
    display: inline-block;
  }

  path {
    fill: ${({ theme, branch }) => theme.colors.branch[branch]};
  }

  ${shadowHighDrop}
`

const InnerContainer = styled.div`
  width: ${({ expand, hasImage }) => (!expand ? 500 : hasImage ? 2048 : 864)}px;
  height: ${({ expand, hasImage }) => (expand ? 1280 : hasImage ? 800 : 300)}px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  border-radius: 1rem;
  background: ${({ theme }) => theme.colors.greys.dark};
  /* TODO: (2) Add gradient OR make full-size image */
`

const Content = styled.div`
  position: absolute;
  right: 0;
  width: ${({ expand }) => (expand ? '864px' : '100%')};
  height: 100%;
  padding-top: ${({ expand }) => (expand ? 0 : 40)}px;
  display: flex;
  align-items: center;
  flex-direction: column;
  transform: translateX(${({ expand, hide }) => (expand && hide ? 94.5 : 0)}%);
  transition: transform 300ms ease-in-out;
`

const MediaContainer = styled.div`
  width: 100%;
  height: 500px;
  position: ${({ inBackground }) => (inBackground ? 'absolute' : 'initial')};
`

const Slider = styled(ImageSlider)`
  position: relative;
`

const SliderCaption = styled(H4)`
  color: ${({ theme }) => theme.colors.text.inverse};
  position: absolute;
  bottom: 3rem;
  left: 4rem;
  max-width: 60rem;
  ${shadowLowText}
`

const CompanyName = styled(H5)`
  margin-bottom: 2rem;
  text-align: center;
  padding: 0 2rem;
  color: ${({ theme }) => theme.colors.text.inverse};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`

const MoreBtn = styled(Button)`
  flex: 0 0 auto;
`

const HideAsideBtn = styled(Button)`
  && {
    position: absolute;
    transition-property: transform, background, color;
    transition-duration: 500ms;
    transition-delay: 200ms;
  }
  z-index: 1;
  left: -2.5rem;
  bottom: 50%;
  transform: translateY(50%) rotateZ(${({ flip }) => (flip ? 180 : 0)}deg);
`

export const PROFILE_VIEW = 'Stammdaten'
export const TEXT_VIEW = 'Kurzgeschichte'
export const ADDRESS_VIEW = 'Adressen'
export const COMPANY_NAMES_VIEW = 'Umfirmierung'

/**
 * Card component that contains images, information, and a description of a company
 */
class CompanyProfile extends Component {
  static defaultProps = {
    expand: false,
    view: PROFILE_VIEW,
    onClick: x => x,
    onClose: x => x,
    onExpand: x => x,
    onCollapse: x => x,
  }

  static propTypes = {
    view: PropTypes.oneOf([
      TEXT_VIEW,
      PROFILE_VIEW,
      ADDRESS_VIEW,
      COMPANY_NAMES_VIEW,
    ]),
    expand: PropTypes.bool,
    company: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    onClose: PropTypes.func,
    onExpand: PropTypes.func,
    onCollapse: PropTypes.func,
  }

  state = {
    view: null,
    showAside: true,
  }

  static getDerivedStateFromProps({ view }, state) {
    if (state.view === null) {
      return { view }
    }
    return null
  }

  handleExpand = e => {
    const { company, onExpand } = this.props
    const { id, currentAddress } = company
    onExpand({ id, ...currentAddress.position })
  }

  handleViewChange = view => e => {
    this.setState({ view })
  }

  handleAsideToggle = () => {
    this.setState({
      showAside: !this.state.showAside,
    })
  }

  handleClick = () => {
    const { onClick, company } = this.props
    onClick(company.id)
  }

  handleClose = e => {
    const { onClose, onCollapse, company, expand } = this.props
    if (expand) {
      onCollapse()
    } else {
      onClose(company.id)
    }
  }

  handleTextOpened = () => {
    this.slider.reset()
    console.log('reset', this.slider)
  }

  render() {
    const { company, theme, expand } = this.props
    const { showAside } = this.state
    const { branch, images, name, employees } = company
    const hasImage = !!images

    return (
      <Wrapper
        expand={expand}
        offset={getMarkerSize(employees)}
        hasImage={hasImage}
      >
        <CloseButton
          bg={theme.colors.branch[branch]}
          icon="cross"
          type="round"
          inverse
          onClick={this.handleClose}
        />
        {/* TODO: (1) Add button to minimize */}
        <div onClick={this.handleClick}>
          <SVG
            src={shapes[expand ? 1 : 0][hasImage ? 1 : 0]}
            branch={branch}
            // onInjected={() => {
            //   console.log('SVG loaded')
            // }}
          />
          <InnerContainer expand={expand} hasImage={hasImage}>
            {hasImage && (
              <MediaContainer inBackground={expand}>
                {expand ? (
                  <Slider
                    ref={ref => {
                      this.slider = ref
                    }}
                    key={`ImageSlider-${expand ? 'large' : 'small'}`}
                    images={images}
                    width={2048}
                    height={1280}
                    spacing={32}
                    showCaption={expand}
                    renderCaption={text => (
                      <SliderCaption>{text}</SliderCaption>
                    )}
                  />
                ) : (
                  <ImageToCanvas url={images[0].url} width={500} height={500} />
                )}
              </MediaContainer>
            )}
            <Content expand={expand} hide={!showAside}>
              {!expand && (
                <>
                  <CompanyName>{name}</CompanyName>
                  <MoreBtn size="small" onClick={this.handleExpand}>
                    Mehr erfahren
                  </MoreBtn>
                </>
              )}
              {expand && (
                <>
                  {hasImage && (
                    <HideAsideBtn
                      type="round"
                      size="medium"
                      icon="right"
                      inverse={!showAside}
                      onClick={this.handleAsideToggle}
                      flip={!showAside}
                    />
                  )}
                  <Aside
                    company={company}
                    onTextOpened={this.handleTextOpened}
                  />
                </>
              )}
            </Content>
          </InnerContainer>
        </div>
      </Wrapper>
    )
  }
}

export default withTheme(CompanyProfile)
